import React, { Component } from "react";
import { Row, Col, Button, InputGroup, FormControl } from "react-bootstrap";

import { getMessage } from "CONFIG/i18n";
import { validateSetPassword } from "UTILS/regexValidations";

import logo from "../../Assets/Images/img_signin_bg_logo.webp";

import ChangeLanguage from "COMPONENTS/CommonComponents/ChangeLanguage/ChangeLanguage";

class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      view: false,
      confirmPassword: "",
      newPassword: "",
      isDisabled: false,
      networkError: this.props.networkError
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.networkError !== this.props.networkError) {
      this.setState({ errorMessage: this.props.networkError });
    }
    if (
      this.props.errorMessage === "Network Error" &&
      this.state.isDisabled === true
    ) {
      this.setState({ isDisabled: false });
    }
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim(),
      errorMessage: "",
      isDisabled: false
    });
  };
  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleChangePassword();
    }
  };

  ChangePasswordFieldView = () => {
    this.setState({ view: !this.state.view });
  };

  handleChangePassword = () => {
    let errorMessage = "";
    if(!this.state.newPassword) {
      errorMessage = this.props.reset ? getMessage("ENTER_NEW_PASSWORD") : getMessage("SET_PASSWORD_REQUIRED");
    } else if(!this.state.confirmPassword) {
      errorMessage = getMessage("ENTER_CONFIRM_PASSWORD")
    } else {
      errorMessage = validateSetPassword(
        this.state.newPassword,
        this.state.confirmPassword
      );
    }
    if (errorMessage) {
      this.setState({ errorMessage: errorMessage });
    } else {
      this.setState({ isDisabled: true });
      let request_data = {
        confirmPassword: this.state.confirmPassword,
        newPassword: this.state.newPassword
      };
      this.props.handleSetPassword(request_data, (message) => {
        if (message.resp !== "success") {
          errorMessage = getMessage(message.error.code, { ...message.error.details });
          this.setState({
            errorMessage: errorMessage
          });
        } else {
          this.setState({
            errorMessage: "",
            newPassword: "",
            confirmPassword: "",
          })
        }
      });
    }
  };

  onSelectChange = selectedLanguage => {
    this.props.setLanguageAction(selectedLanguage);
  };

  render() {
    return (
      <div className="container-fluid SignIn">
        <div className= "languageSelection">
          <div className="noMargin">
            <ChangeLanguage
              onSelectChange={this.onSelectChange}
              language={this.props.language}
            />
          </div>
        </div>
        <Row className="setPasswordInner">
          <Col md={12} xs={12} lg={12} xl={12} className="SignInContainer">
            <Row>
              <Col md={12} className="text-center">
                <img className=" img-fluid SignInLogo" src={logo} />
              </Col>
            </Row>
            <Row>
              <Col md={12} className="text-center">
                <label className="SignInLabel">
                  {
                    this.props.reset ?
                      getMessage("RESET_PASSWORD_TITLE") : getMessage("SET_PASSWORD_TITLE")
                  }
                </label>
              </Col>
            </Row>
            <Row>
              <Col>
                <label className="SignInPasswordLabel text-left">
                  {
                    this.props.reset ?
                      getMessage("NEW_PASSWORD") : getMessage("PASSWORD")
                  }
                </label>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup>
                  <FormControl
                    type={this.state.view ? "text" : "password"}
                    onChange={this.handleInputChange}
                    name="newPassword"
                    autoFocus={true}
                    className="SignInPasswordInput"
                    onKeyPress={this.enterPressed}
                    value={this.state.newPassword}
                  />
                </InputGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <label className="SignInPasswordLabel text-left">
                  {
                    this.props.reset ?
                      getMessage("RESET_CONFIRM_PASSWORD") : getMessage("SET_CONFIRM_PASSWORD")
                  }
                </label>
              </Col>
            </Row>
            <Row>
              <Col>
                <InputGroup>
                  <FormControl
                    type={this.state.view ? "text" : "password"}
                    onChange={this.handleInputChange}
                    name="confirmPassword"
                    className="SignInPasswordInput"
                    onKeyPress={this.enterPressed}
                    value={this.state.confirmPassword}
                  />
                </InputGroup>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className="text-right SignInForgotLabelContainer" />
                <Button
                  className="customBtn btnSignIn whiteOnClick"
                  onClick={this.handleChangePassword}
                  disabled={this.state.isDisabled}
                >
                  {getMessage("SET_PASSWORD_BUTTON")}
                </Button>
                <div className="errors ">{this.state.errorMessage}</div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}
export default SetPassword;
